import api from './api';

const NetworkService = {
  login: (data) => api.post('auth/admin', data),
  refresh: () => api.get('auth/admin'),
};

export default NetworkService;
